import {
  AppBar,
  Box,
  ButtonBase,
  IconButton,
  SvgIcon,
  Toolbar,
} from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import PropTypes from "prop-types";
import React from "react";
import { LogOut as LogoutIcon, Menu as MenuIcon } from "react-feather";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../../../components/Logo";
import { THEMES } from "../../../constants";
import { useDispatch } from "react-redux";
import { logout } from "../../../actions/accountActions";
import { useHistory } from "react-router";


const useStyles = makeStyles()((theme: any) => ({
  root: {
    // zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
        boxShadow: "none",
        backgroundColor: theme.palette.primary.main,
      }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
        backgroundColor: theme.palette.background.default,
      }
      : {}),
  },
  toolbar: {
    minHeight: 64,
  },
}));

function TopBar({ className, onMobileNavOpen, ...rest }) {
  const { classes, cx } = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogout = async () => {
    await dispatch(logout());
    history.push("/login");
  };

  return (
    (<AppBar className={cx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
          <IconButton className={""} color="inherit" onClick={onMobileNavOpen} size="large">
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
        </Box>
        <Box
          sx={{
            ml: 2,
            flexGrow: 1
          }} />
        <ButtonBase>
          <LogoutIcon onClick={handleLogout} />
        </ButtonBase>
      </Toolbar>
    </AppBar>)
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
